import {makeAutoObservable} from "mobx";


const logPrefix  = "[SummaryContentStore]"
export default class SummaryContentStore {

    constructor(props) {
        this.commonStore = props.commonStore;
        this.contentRepository = props.contentRepository;
        this.summaryContentCount = 0;
        this.summaryContentList = [];
        this.selectedStep = 0;
        this.selectedDay =  0;
        this.tempSelectedStep = 0;
        this.tempSelectedDay =  0;
        this.sortColumn = '';
        this.isSortAscending = true;
        this.rowsPerPage = 10;
        this.page = 0;

        makeAutoObservable(this);
    }

    init = () => {
        this.summaryContentCount = 0;
        this.summaryContentList = [];
    }

    setSelectedStep = (step) => {
        this.selectedStep = step;
    }

    setSelectedDay = (day) => {
        this.selectedDay = day;
    }

    setTempSelectedStep = (step) => {
        this.tempSelectedStep = step;
    }

    setTempSelectedDay = (day) => {
        this.tempSelectedDay = day;
    }

    setSearchValue = () => {
        this.selectedStep = this.tempSelectedStep;
        this.selectedDay = this.tempSelectedDay;
    }

    setSortColumn = (column) => {
        this.sortColumn = column;
    }

    setIsSortAscending = (isAscending) => {
        this.isSortAscending = isAscending;
    }

    setRowsPerPage = (rowsPerPage) => {
        this.rowsPerPage = rowsPerPage;
        this.getSummaryContents();
    }

    setPage = (page) => {
        this.page = page;
        this.getSummaryContents();
    }

    *getSummaryContents() {
        this.commonStore.setLoadingState();
        try {
            console.log(logPrefix, 'Start getSummaryContents.');
            const url = `summary?step=${this.selectedStep}&day=${this.selectedDay}&rows-per-page=${this.rowsPerPage}&page=${this.page + 1}&sortColumn=${this.sortColumn}&isAscending=${this.isSortAscending}`;
            const result = yield this.contentRepository.getSummaryContents(url);
            this.summaryContentCount = result.data.totalCount;
            this.summaryContentList = result.data.contentList;

            console.log(logPrefix, 'Finished getSummaryContents.');
        } catch (e) {
            console.log(logPrefix, 'Failed getSummaryContents. error=' + e);
        } finally {
            this.commonStore.initLoadingState();
        }
    }
}

